<template>
  <v-container>

          <v-btn color="secondary" @click="openPDF" class="mb-5">Get report</v-btn>
          <v-btn color="secondary" @click="openSpeel" class="mb-5">Telemarketing Speel</v-btn>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Phone Calls
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="showAddDialog">Add Phone Call</v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="phoneCalls"
              item-key="id"
              :search="search"
              :loading="loading"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [10],
                'items-per-page-text': 'Rows per page'
              }"
              @update:page="fetchPhoneCalls"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field v-model="search" clearable placeholder="Search..."></v-text-field>
                  <v-spacer></v-spacer>
                     <v-menu
        v-model="dateMenu"
        :close-on-content-click="false"
        transition="slide-x-reverse-transition"
        max-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRangeText"
            label="Date range"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-card>
          <v-card-text>
            <v-date-picker
              v-model="dates"
              range
              @input="updateDateRangeText"
              :disabled-weekdays="[0, 6]"
              first-day-of-week="1"
            ></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="clearDateRange">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    <v-spacer></v-spacer>
    <v-select
      v-model="selectedCallResult"
      :items="callResultsOptions"
      label="Call Results"
      clearable
    ></v-select>
    <v-spacer></v-spacer>

                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon v-if="item.allow_changes" @click="editPhoneCall(item)" class="mr-2">mdi-pencil</v-icon>
                <v-icon v-else disabled class="mr-2">mdi-pencil</v-icon>

                <v-icon v-if="item.allow_changes" @click="deletePhoneCall(item)">mdi-delete</v-icon>
                <v-icon v-else disabled>mdi-delete</v-icon>

                <v-btn v-if="item.call_results === '*' && item.outcomes === null" @click="openDummyDialog(item)" text>{{ dummyText }}</v-btn>
                <v-btn v-else disabled text>{{ item.outcomes }}</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dummyDialog" max-width="600px">
  <v-card>
    <v-card-title>
      Appointment Status
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="dummyDialogAction">
        <v-radio-group v-model="presentationStatus" row>
          <v-radio value="missed" label="Missed"></v-radio>
          <v-radio value="unsuccessful" label="Unsuccessful"></v-radio>
          <v-radio value="successful" label="Successful"></v-radio>
        </v-radio-group>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeDummyDialog">Close</v-btn>
      <v-btn color="blue darken-1" text @click="dummyDialogAction">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

{{/* New Appointment Dialog */}}
<v-dialog v-model="appointmentDialog" max-width="fit-content">
  <v-card>
    <v-card-title>
      Schedule Appointment
    </v-card-title>
    <v-card-text>
  <v-form @submit.prevent="saveAppointment">
    {{/* Use Vuetify grid for side-by-side pickers */}}
    <v-row>
      <v-col cols="12" sm="6"> {{/* On small screens and up, take half width */}}
        <v-date-picker v-model="appointmentDate" label="Appointment Date" type="date"></v-date-picker>
      </v-col>
      <v-col cols="12" sm="6"> {{/* On small screens and up, take half width */}}
        <v-time-picker
          v-model="appointmentTime"
          label="Appointment Time"
          format="ampm" 
          scrollable 
        ></v-time-picker>
      </v-col>
    </v-row>

    {{/* Display selected date and time together */}}
    <div class="mt-4 text-center"> {{/* Add some margin top and center text */}}
      <p v-if="appointmentDate || appointmentTime"> {{/* Show only if at least one is selected */}}
        Selected: <strong>{{ appointmentDate }} {{ appointmentTime }}</strong>
      </p>
    </div>

  </v-form>
</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeAppointmentDialog">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="saveAppointment">Save Appointment</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="unsuccessfulDialog" max-width="600px">
  <v-card>
    <v-card-title>
      Unsuccessful Presentation
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="saveUnsuccessfulPresentation">
        <v-textarea v-model="unsuccessfulNotes" label="Reason for not buying"></v-textarea>
        <v-date-picker v-model="unsuccessfulDate" label="Date" type="date"></v-date-picker>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeUnsuccessfulDialog">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="saveUnsuccessfulPresentation">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="missedDialog" max-width="600px">
  <v-card>
    <v-card-title>
      Missed Presentation
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="saveMissedPresentation">
        <v-textarea v-model="missedNotes" label="Action taken"></v-textarea>
        <v-slider v-model="missedRate" label="Rate" min="1" max="10"></v-slider>
        <v-date-picker v-model="missedDate" label="Date" type="date"></v-date-picker>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeMissedDialog">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="saveMissedPresentation">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ editMode ? 'Edit Phone Call' : 'Add Phone Call' }}
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="savePhoneCall">
            <v-text-field v-model="editedPhoneCall.business_name" label="Business Name"></v-text-field>
            <v-text-field v-model="editedPhoneCall.phone_number" label="Phone Number"></v-text-field>
            <v-text-field v-model="editedPhoneCall.address" label="Address"></v-text-field>
            <v-select v-model="editedPhoneCall.call_results" :items="callResults" label="Call Results"></v-select>
            <v-textarea v-model="editedPhoneCall.notes" label="Notes(Optional)"></v-textarea>
            <v-radio-group v-model="editedPhoneCall.source" row>
              <v-radio value="Online" label="Online"></v-radio>
              <v-radio value="Business Card" label="Business Card"></v-radio>
              <v-radio value="Others" label="Others"></v-radio>
            </v-radio-group>
            <v-text-field v-if="editedPhoneCall.source === 'Others'" v-model="otherSource" label="Other Source"></v-text-field>
            <v-menu
              v-model="callDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="editedPhoneCall.call_date"
                  label="Call Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="editedPhoneCall.call_date"
                @change="callDateMenu = false" 
              />
            </v-menu>

            <v-expansion-panels v-if="editMode === false">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <v-row no-gutters>
                      <v-col cols="4">
                        Callback requested
                      </v-col>
                      <v-col cols="8" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0">
                            Select the date for callback
                          </span>
                          <span v-else key="1">
                            {{ option }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-radio-group v-model="option" row>
                      <v-radio label="Yes" value="Yes"></v-radio>
                      <v-radio label="No" value="No"></v-radio>
                    </v-radio-group>
                  </v-row>

                  <v-row no-gutters v-if="option === 'Yes'">
                    <v-col cols="3">
                      <v-menu
                        ref="optionDateMenu"
                        :close-on-content-click="false"
                        :return-value.sync="selectedDate"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="selectedDate"
                            label="Select date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.optionDateMenu.isActive = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.optionDateMenu.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="savePhoneCall">{{ editMode ? 'Save' : 'Add' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { axios } from '../../../utils';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    // Calculate the default range: Sunday to Saturday of last week's Monday
    const today = new Date();
    // Calculate the date of the Sunday of the current week (0 = Sunday)
    const currentSunday = new Date(today);
    currentSunday.setDate(today.getDate() - today.getDay());

    // Calculate the date of the Sunday of *last* week
    const lastWeekSunday = new Date(currentSunday);
    lastWeekSunday.setDate(currentSunday.getDate() - 7);

    // Calculate the date of the Saturday of last week
    const lastWeekSaturday = new Date(lastWeekSunday);
    lastWeekSaturday.setDate(lastWeekSunday.getDate() + 6);

    const defaultStartDate = lastWeekSunday.toISOString().substr(0, 10);
    const defaultEndDate = lastWeekSaturday.toISOString().substr(0, 10);

    return {
      callDateMenu: false,
      appointmentDialog: false, // Controls visibility of the new appointment dialog
      appointmentDate: new Date().toISOString().substr(0, 10), // Default to today's date
      appointmentTime: '', // To store the appointment time (e.g., '14:30')
      newlyCreatedPhoneCallId: null, 
      date: null,
      option: 'No',
      selectedDate: null,
      phoneCalls: [],
      loading: false,
      search: '',
      lastWeekDate: null, // Initialize lastWeekDate
      headers: [
        { text: 'Business Name', value: 'business_name' },
        { text: 'Phone Number', value: 'phone_number' },
        { text: 'Call Results', value: 'call_results' },
        { text: 'Address', value: 'address' },          // ← add this line
        { text: 'Call Date', value: 'call_date' },
        { text: 'Notes', value: 'notes' },
        { text: 'Source', value: 'source' },    
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dialog: false,
      dummyDialog: false,
      dummyText: 'Update',
      presentationStatus: null,
      otherSource: '',
      editedPhoneCall: {
        business_name: '',
        phone_number: '',
          address: '',                // ← add
        call_results: '',
        notes: '',
        source: null,
        outcomes: null,
        call_date: new Date().toISOString().substr(0, 10), // Today's date as default
        employee_id: this.userId // This will be set in mounted after userId is available from props
      },
      userId: null,
      editMode: false,
      selectedPhoneCallId: null,
      callResults: ['x', '*', '/'], // Options for call results
      unsuccessfulDialog: false,
      missedDialog: false,
      unsuccessfulNotes: '',
      missedNotes: '',
      missedRate: 5, // Default rate
      unsuccessfulDate: new Date().toISOString().substr(0, 10), // Today's date as default
      missedDate: new Date().toISOString().substr(0, 10), // Today's date as default
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
      // startDate: null, // Start date for the range filter - Replaced by dates array
      // endDate: null,   // End date for the range filter - Replaced by dates array
      selectedCallResult: null, // Selected call result filter
      callResultsOptions: ['*', '/', 'x'], // Options for call results
      dates: [defaultStartDate, defaultEndDate], //* Default to last Monday's week range */}}
      dateRangeText: `${defaultStartDate} - ${defaultEndDate}`, //* Display the default range */}}
      dateMenu: false,
      lastDatesKey: null,
      debouncedFetchPhoneCalls: null,
    };
  },
  created() {
  this.debouncedFetchPhoneCalls = this.debounce(this.fetchPhoneCalls, 300);
  },
  mounted() {
    this.lastWeekDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
    this.userId = this.id;
    // Ensure editedPhoneCall has employee_id set from prop when mounted
    this.editedPhoneCall.employee_id = this.userId;
    this.fetchPhoneCalls(); // This will now use the default dates set in data()
    console.log(this.id, 'from phone calls mounted')
  },
  methods: {
  debounce(fn, wait = 300) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  },
    openPDF() {
    const pdfUrl = 'https://www.bluebusinessguide.com.au/pdfs/Sales_KPI.pdf'; // Replace with your actual PDF path
    window.open(pdfUrl, '_blank'); // Opens the PDF in a new tab
  },
  openSpeel() {
    const pdfUrl = 'https://www.bluebusinessguide.com.au/pdfs/telemarketing_speel.pdf'; // Replace with your actual PDF path
    window.open(pdfUrl, '_blank'); // Opens the PDF in a new tab
  },
  updateDateRangeText() {
  if (this.dates && this.dates.length === 2 && this.dates[0] && this.dates[1]) {
    const [start, end] = [...this.dates].sort();
    this.dateRangeText = `${start} - ${end}`;
    this.dateMenu = false;           // ✅ close ONLY when both picked
  } else {
    // First click (only one date selected): keep menu open
    this.dateRangeText = Array.isArray(this.dates) && this.dates[0]
      ? `${this.dates[0]} - …`       // optional: show a “partial” range
      : '';
    // ❌ do NOT close the menu here
  }
}
,
  clearDateRange() {
    this.dates = [];  // Clear the selected dates
    this.dateRangeText = '';  // Clear the displayed text
    this.dateMenu = false;  // Close the menu
  },
    async fetchPhoneCalls() {
  this.loading = true;
  try {
    const response = await axios.get(`/api/admin/phone-calls/employee-call-list/${this.id}`, {
      params: {
        page: this.page,
        // Use the dates array for start_date and end_date
        start_date: this.dates && this.dates.length === 2 ? this.dates[0] : null,
        end_date: this.dates && this.dates.length === 2 ? this.dates[1] : null,
        call_result: this.selectedCallResult,
        search: this.search // Add the search term to the parameters
      }
    });
    const phoneCallsData = response.data.data;
    this.totalItems = response.data.total;
    this.phoneCalls = phoneCallsData.map(item => ({
      ...item,
      allow_changes: new Date(item.call_date) > this.lastWeekDate // Set allow_changes based on call_date
    }));
  } catch (error) {
    console.error('Error fetching phone calls:', error);
  } finally {
    this.loading = false;
  }
}
,
      async savePhoneCall() {
  console.log('DEBUG before save', {
    radio: this.editedPhoneCall.source,   // "Others"
    otherSource: this.otherSource         // e.g. "referral"
  });

  this.loading = true;
  try {
    // Build a clean payload (don’t mutate the live form model)
    const payload = { ...this.editedPhoneCall };

    // Map "Others" -> free-text value
    if (payload.source === 'Others') {
      const actual = (this.otherSource || '').trim();
      if (!actual) {
        this.loading = false;
        alert('Please enter a source for "Others".');
        return;
      }
      payload.source = actual;  // <-- CRITICAL: send "referral", not "Others"
    }

    // Ensure employee_id is present
    payload.employee_id = this.userId;

    let phoneCallResponse;

    if (this.editMode) {
      phoneCallResponse = await axios.put(
        `/api/admin/phone-calls/${this.selectedPhoneCallId}`,
        payload
      );
      console.log('Phone call updated:', phoneCallResponse.data);
      this.closeDialog();

    } else {
      phoneCallResponse = await axios.post('/api/admin/phone-calls', payload);
      console.log('New phone call created:', phoneCallResponse.data);

      if (phoneCallResponse.data && phoneCallResponse.data.call_results === '*') {
        this.newlyCreatedPhoneCallId = phoneCallResponse.data.id;
        this.closeDialog();
        this.$nextTick(() => this.openAppointmentDialog());
      } else {
        this.closeDialog();

        if (this.option === 'Yes' && this.selectedDate) {
          const phoneCallId = phoneCallResponse.data.id;
          await axios.post('/api/admin/callbacks', {
            call_date: this.selectedDate,
            phone_call_id: phoneCallId,
            employee_id: this.userId,
          });
          console.log('Callback saved successfully');
          this.selectedDate = null;
          this.date = null;
          this.option = 'No';
        }
      }
    }

    // refresh table
    this.fetchPhoneCalls();

  } catch (error) {
    console.error('Error saving phone call:', error.response?.data || error.message);
  } finally {
    this.loading = false;
  }
}
,

  openAppointmentDialog() { // Modified to not take 'item' directly, uses newlyCreatedPhoneCallId
    if (!this.newlyCreatedPhoneCallId) {
        console.error("No phone call ID available to schedule appointment.");
        return;
    }
    this.appointmentDialog = true;
    // Reset date/time inputs to defaults
    this.appointmentDate = new Date().toISOString().substr(0, 10);
    this.appointmentTime = ''; // Or a default time like '09:00'
  },

  closeAppointmentDialog() {
    this.appointmentDialog = false;
    this.newlyCreatedPhoneCallId = null; // Clear the stored ID
    // Optionally clear inputs
    // this.appointmentDate = new Date().toISOString().substr(0, 10);
    // this.appointmentTime = '';
     // You might want to re-open the main dialog or do something else here
     // if the user cancels the appointment scheduling.
     // For this flow, assuming cancelling appointment means closing both.
     this.closeDialog(); // Close the main phone call dialog as well
  },

  async saveAppointment() {
    if (!this.newlyCreatedPhoneCallId || !this.appointmentDate || !this.appointmentTime) {
      console.error('Missing appointment details or phone call ID');
      // Optionally show a user-friendly message
      return;
    }

    this.loading = true; // Indicate loading

    try {
      let timeString = '00:00:00'; // Default or error value

      if (this.appointmentTime instanceof Date && !isNaN(this.appointmentTime)) {
        timeString = this.appointmentTime.toLocaleTimeString('en-AU'); // "HH:MM:SS" format
        // For more specific control without relying on locale, or if you need a different format:
        // const hours = this.appointmentTime.getHours().toString().padStart(2, '0');
        // const minutes = this.appointmentTime.getMinutes().toString().padStart(2, '0');
        // const seconds = this.appointmentTime.getSeconds().toString().padStart(2, '0');
        // timeString = `${hours}:${minutes}:${seconds}`;
      } else if (typeof this.appointmentTime === 'string') {
        // If it's already a string, assume it's in the correct time format or handle/validate
        timeString = this.appointmentTime; // e.g., "14:30" or "14:30:00"
      }
      // Make the API call to create the appointment
      const response = await axios.post('/api/admin/appointments-calendar', {
        phone_call_id: this.newlyCreatedPhoneCallId, // Use the stored ID
        appointments_date: this.appointmentDate,
        appointments_time: timeString,
        // Add employee_id if your backend requires it directly on the appointment table
        // employee_id: this.userId,
      });

      console.log('Appointment saved:', response.data);

      // Optional: Update the phone call outcome to indicate an appointment was scheduled
      // You might need a separate API call or update your backend store logic
      // await axios.put(`/api/admin/phone-calls/${this.newlyCreatedPhoneCallId}`, {
      //    outcomes: 'Appointment Scheduled' // Or similar status
      // });


      this.closeAppointmentDialog(); // Close the appointment dialog
      // The main dialog is already closed by closeAppointmentDialog
      this.fetchPhoneCalls(); // Refresh the main phone calls list

    } catch (error) {
      console.error('Error saving appointment:', error.response?.data || error.message);
      // Optionally show a user-friendly error message from error.response.data.message
    } finally {
      this.loading = false; // Stop loading indicator
    }
  },
    editPhoneCall(item) {
      this.editMode = true;
      this.selectedPhoneCallId = item.id;
      // Deep copy item data to editedPhoneCall to avoid modifying original item
      this.editedPhoneCall = JSON.parse(JSON.stringify(item));
      // If source is 'Others', populate otherSource for display
      if (!['Online', 'Business Card'].includes(this.editedPhoneCall.source)) {
         this.otherSource = this.editedPhoneCall.source;
         this.editedPhoneCall.source = 'Others'; // Set radio button to Others
      } else {
         this.otherSource = ''; // Clear otherSource if not 'Others' source
      }
      this.dialog = true;
    },
    async deletePhoneCall(item) {
      if (confirm('Are you sure you want to delete this phone call?')) {
         this.loading = true; // Start loading indicator
        try {
           await axios.delete(`/api/admin/phone-calls/${item.id}`);
           this.fetchPhoneCalls(); // Refresh list after deletion
        } catch (error) {
           console.error('Error deleting phone call:', error);
           // Optionally show error message
        } finally {
           this.loading = false; // Stop loading indicator
        }
      }
    },
    showAddDialog() {
      this.editMode = false;
      this.selectedPhoneCallId = null;
      // Reset editedPhoneCall to defaults
      this.editedPhoneCall = {
        business_name: '',
        phone_number: '',
          address: '',                // ← add
        call_results: '',
        notes: '',
        source: null,
        outcomes: null,
        call_date: new Date().toISOString().substr(0, 10), // Today's date as default
        employee_id: this.userId // Ensure employee_id is set
      };
      this.otherSource = ''; // Clear other source field
      // Reset callback specific data for add mode
      this.option = 'No';
      this.selectedDate = null;
      this.date = null; // Clear date picker model
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      // Reset editMode and selectedPhoneCallId on close
      this.editMode = false;
      this.selectedPhoneCallId = null;
      // Optionally reset editedPhoneCall here as well, though showAddDialog also resets it
      this.$nextTick(() => {
         this.editedPhoneCall = { // Reset to a clean state
           business_name: '',
           phone_number: '',
           call_results: '',
             address: '',                // ← add
           notes: '',
           source: null,
           outcomes: null,
           call_date: new Date().toISOString().substr(0, 10),
           employee_id: this.userId
         };
         this.otherSource = '';
         this.option = 'No';
         this.selectedDate = null;
         this.date = null;
      });
    },
    openDummyDialog(item) {
      this.dummyDialog = true;
      this.selectedPhoneCallId = item.id;
      // Copy item data to editedPhoneCall for potential outcome update
      this.editedPhoneCall = { ...item };
      this.presentationStatus = null; // Reset status selection
    },
    closeDummyDialog() {
      this.dummyDialog = false;
      // this.presentationStatus = null; // Reset status selection on close
    },
    async dummyDialogAction() {
      // This method is called on Save from the dummy dialog
      // It saves the outcome to the phone call and then potentially opens the specific dialogs

      if (this.presentationStatus === 'successful') {
         this.loading = true; // Start loading
        try {
           await axios.put(`/api/admin/phone-calls/${this.selectedPhoneCallId}`, {
             ...this.editedPhoneCall, // Include other fields just in case
             outcomes: 'Sale' // Set outcome to Sale
           });
           console.log('Phone call outcome updated to Sale');
           this.fetchPhoneCalls(); // Refresh list
        } catch (error) {
           console.error('Error updating phone call outcome to Sale:', error);
           // Optionally show error message
        } finally {
           this.loading = false; // Stop loading
           this.closeDummyDialog(); // Close the dummy dialog after action
        }
      } else {
        // If not 'successful', close the dummy dialog and open the specific one
        this.closeDummyDialog(); // Close the dummy dialog
        this.$nextTick(() => { // Use nextTick to ensure dummy dialog is fully closed
           this.openDialogs(); // Open the relevant specific dialog
        });
      }
    },
    openDialogs() {
      // Opens the specific outcome dialog based on presentationStatus
      if (this.presentationStatus === 'unsuccessful') {
        this.unsuccessfulDialog = true;
        // Reset specific dialog form data
        this.unsuccessfulNotes = '';
        this.unsuccessfulDate = new Date().toISOString().substr(0, 10);
      } else if (this.presentationStatus === 'missed') {
        this.missedDialog = true;
        // Reset specific dialog form data
        this.missedNotes = '';
        this.missedRate = 5;
        this.missedDate = new Date().toISOString().substr(0, 10);
      }
    },
    closeUnsuccessfulDialog() {
      this.unsuccessfulDialog = false;
       this.selectedPhoneCallId = null; // Clear selected ID
       this.editedPhoneCall = {}; // Clear edited item
       this.presentationStatus = null;
    },
    closeMissedDialog() {
      this.missedDialog = false;
       this.selectedPhoneCallId = null; // Clear selected ID
       this.editedPhoneCall = {}; // Clear edited item
       this.presentationStatus = null;
    },
    async saveUnsuccessfulPresentation() {
      if (!this.selectedPhoneCallId) return; // Prevent saving if no call is selected
       this.loading = true; // Start loading
      try {
        await Promise.all([
          // Update phone call outcome to 'Failed'
          axios.put(`/api/admin/phone-calls/${this.selectedPhoneCallId}`, {
            ...this.editedPhoneCall, // Include other fields
            outcomes: 'Failed'
          }),
          // Create new appointment result record
          axios.post('/api/admin/appointment-results', {
            phone_call_id: this.selectedPhoneCallId, // Link to the phone call
            business_name: this.editedPhoneCall.business_name, // Use data from the phone call
            phone_number: this.editedPhoneCall.phone_number, // Use data from the phone call
            notes: this.unsuccessfulNotes,
            date: this.unsuccessfulDate,
            employee_id: this.userId, // Ensure employee_id is included
            type: 'Failed'
            // Rate is not applicable for 'Failed'
          })
        ]);
        console.log('Unsuccessful presentation saved.');
        this.fetchPhoneCalls(); // Refresh list
      } catch (errors) {
        console.error('Error saving unsuccessful presentation:', errors);
         // Optionally show error message
      } finally {
        this.loading = false; // Stop loading
        this.closeUnsuccessfulDialog(); // Close the dialog
      }
    },
    async saveMissedPresentation() {
       if (!this.selectedPhoneCallId) return; // Prevent saving if no call is selected
        this.loading = true; // Start loading
      try {
        await Promise.all([
          // Update phone call outcome to 'Missed'
          axios.put(`/api/admin/phone-calls/${this.selectedPhoneCallId}`, {
            ...this.editedPhoneCall, // Include other fields
            outcomes: 'Missed'
          }),
          // Create new appointment result record
          axios.post('/api/admin/appointment-results', {
            phone_call_id: this.selectedPhoneCallId, // Link to the phone call
            business_name: this.editedPhoneCall.business_name, // Use data from the phone call
            phone_number: this.editedPhoneCall.phone_number, // Use data from the phone call
            notes: this.missedNotes,
            date: this.missedDate,
            employee_id: this.userId, // Ensure employee_id is included
            type: 'Missed',
            rate: this.missedRate // Include the rate
          })
        ]);
        console.log('Missed presentation saved.');
        this.fetchPhoneCalls(); // Refresh list
      } catch (errors) {
        console.error('Error saving missed presentation:', errors);
         // Optionally show error message
      } finally {
        this.loading = false; // Stop loading
        this.closeMissedDialog(); // Close the dialog
      }
    }
  },
  watch: {
   dates(newDates) {
    if (Array.isArray(newDates) && newDates.length === 2 && newDates[0] && newDates[1]) {
      const [start, end] = [...newDates].sort(); // ✅ copy first
      const key = `${start}::${end}`;
      if (this.lastDatesKey === key) return;     // ✅ don’t refetch same range
      this.lastDatesKey = key;
      this.dateRangeText = `${start} - ${end}`;
      this.debouncedFetchPhoneCalls();           // ✅ debounce
    } else if (Array.isArray(newDates) && newDates.length === 0) {
      if (this.lastDatesKey !== null) this.lastDatesKey = null;
      this.dateRangeText = '';
      this.debouncedFetchPhoneCalls();
    }
  },
  selectedCallResult() {
    this.debouncedFetchPhoneCalls();
  },
  search() {
    // Add a debounce here for better performance on long search strings
    // For simplicity, calling fetch immediately
    this.fetchPhoneCalls();
  },
   'editedPhoneCall.source'(newVal, oldVal) {
  const standard = ['Online', 'Business Card'];

  if (newVal !== 'Others') {
    this.otherSource = '';
    return;
  }

  // newVal === 'Others': if we switched from a custom source, prefill the text box
  if (this.editMode && oldVal && !standard.includes(oldVal) && oldVal !== 'Others') {
    this.otherSource = oldVal;
  } else {
    this.otherSource = '';
  }
}

}

};
</script>

<style scoped>
/* Add your custom styles here */
</style>